import './vehiculos.css';

export default function VehiculoComercialForm({ value, onChange, errors, activo, onActivoChange }) {
  const handleChange = (field, fieldValue) => {
    if (typeof onChange === 'function') {
      onChange({ ...value, [field]: fieldValue });
    }
  };

  return (
    <div className="form-section">
      <div className="form-field" data-error={Boolean(errors?.costoKm)}>
        <label htmlFor="vehiculo-costo-km">Costo por km (ARS)</label>
        <input
          id="vehiculo-costo-km"
          name="costoKm"
          type="number"
          min="0"
          value={value.costoKm ?? ''}
          onChange={event => handleChange('costoKm', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.costoKm && <span className="field-error">{errors.costoKm}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.costoHora)}>
        <label htmlFor="vehiculo-costo-hora">Costo por hora (ARS)</label>
        <input
          id="vehiculo-costo-hora"
          name="costoHora"
          type="number"
          min="0"
          value={value.costoHora ?? ''}
          onChange={event => handleChange('costoHora', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.costoHora && <span className="field-error">{errors.costoHora}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.costoFijoMensual)}>
        <label htmlFor="vehiculo-costo-fijo">Costo fijo mensual (ARS)</label>
        <input
          id="vehiculo-costo-fijo"
          name="costoFijoMensual"
          type="number"
          min="0"
          value={value.costoFijoMensual ?? ''}
          onChange={event => handleChange('costoFijoMensual', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.costoFijoMensual && <span className="field-error">{errors.costoFijoMensual}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.propietario)}>
        <label htmlFor="vehiculo-propietario">Propietario / Empresa</label>
        <input
          id="vehiculo-propietario"
          name="propietario"
          value={value.propietario ?? ''}
          onChange={event => handleChange('propietario', event.target.value)}
          placeholder="Flota propia"
        />
        {errors?.propietario && <span className="field-error">{errors.propietario}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.choferAsignado)}>
        <label htmlFor="vehiculo-comercial-chofer">Chofer asignado</label>
        <input
          id="vehiculo-comercial-chofer"
          name="choferAsignado"
          value={value.choferAsignado ?? ''}
          onChange={event => handleChange('choferAsignado', event.target.value)}
          placeholder="Juan Pérez"
        />
        {errors?.choferAsignado && <span className="field-error">{errors.choferAsignado}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.activo)}>
        <label htmlFor="vehiculo-activo">Vehículo activo</label>
        <div className="form-control-group">
          <span className="status-hint">{activo ? 'Disponible para asignar' : 'Fuera de servicio'}</span>
          <button
            type="button"
            id="vehiculo-activo"
            className="switch-control"
            role="switch"
            aria-checked={activo}
            onClick={() => onActivoChange?.(!activo)}
          >
            <span
              style={{
                display: 'block',
                width: '22px',
                height: '22px',
                borderRadius: '999px',
                background: activo ? 'var(--accent)' : 'rgba(148,163,184,0.8)',
                transform: `translateX(${activo ? 22 : 2}px)`,
                transition: 'transform 0.2s ease, background 0.2s ease',
                margin: '2px',
              }}
            />
          </button>
        </div>
        {errors?.activo && <span className="field-error">{errors.activo}</span>}
      </div>
    </div>
  );
}
